<template>
  <a-modal :title="title" :footer="null" v-model="visible" @ok="handleOk" class="ranking-list-model">
    <div class="ranking-list">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-select style="width: 100%;" v-model="offsetDayName" placeholder="选择时间" @change="selectDate">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in dateList" :key="index">{{ item.date }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="4" :sm="6">
          <a-select style="width: 100%;" v-model="pageSizeName" placeholder="选择排名" @change="selectRanking">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in ranking" :key="index">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1">
          <div slot="tab" class="tab-title">
            <span>按销量</span>
          </div>
          <a-table id="table-box" :columns="columns" :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :dataSource="dataSource" :pagination="false" rowKey="id" :scroll="{ y: 100 }">
            <template slot="serialNum" slot-scope="text, record, index">
              <span>{{ index+1 }}</span>
            </template>
            <template slot="productName" slot-scope="text, record">
              <div class="basics-row">
                <div class="overflow-hidden">{{ text }}</div>
                <div class="overflow-hidden">{{ record.productCode }}</div>
              </div>
            </template>
            <template slot="productModel" slot-scope="text, record">
              <div class="basics-row">
                <div class="overflow-hidden">{{ text }}</div>
                <div class="overflow-hidden">{{ record.productSpecification }}</div>
              </div>
            </template>
            <template slot="salesCount" slot-scope="text">
              <div class="salesCount-seniority" :style="{width: getWidth(text) }">
                <span>{{  text }}</span>
              </div>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2">
          <div slot="tab" class="tab-title">
            <span>按销售额</span>
          </div>
          <a-table id="table-box" :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" :scroll="{ y: 300 }">
            <template slot="serialNum" slot-scope="text, record, index">
              <span>{{ index+1 }}</span>
            </template>
            <template slot="productName" slot-scope="text, record">
              <div class="basics-row">
                <div class="overflow-hidden">{{ text }}</div>
                <div class="overflow-hidden">{{ record.productCode }}</div>
              </div>
            </template>
            <template slot="productModel" slot-scope="text, record">
              <div class="basics-row">
                <div class="overflow-hidden">{{ text }}</div>
                <div class="overflow-hidden">{{ record.productSpecification }}</div>
              </div>
            </template>
            <template slot="salesCount" slot-scope="text">
              <div class="salesCount-seniority" :style="{width: getWidth(text) }">
                <span>{{  text }}</span>
              </div>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
import { getSellReportList } from "@/utils/api"
export default {
  name: 'rankinglist',
  data () {
    return {
      visible: false,
      title: '销售排行榜',
      dateList: [
        {
          num: 7,
          date: '近7天'
        }, {
          num: 30,
          date: '近30天'
        }, {
          num: 180,
          date: '近半年'
        }
      ],
      ranking: [
        {
          num: 5,
          name: 'Top 5'
        }, {
          num: 10,
          name: 'Top 10'
        }, {
          num: 20,
          name: 'Top 20'
        }
      ],
      columns: [
        {
          width: 78,
          title: '序号',
          align: "center",
          dataIndex: 'serialNum',
          scopedSlots: { customRender: 'serialNum' }
        }, {
          width: 150,
          title: '基本信息',
          dataIndex: 'productName',
          scopedSlots: { customRender: 'productName' }
        }, {
          width: 150,
          title: '',
          dataIndex: 'productModel'
        }, {
          width: 500,
          title: '',
          dataIndex: 'salesCount',
          scopedSlots: { customRender: 'salesCount' }
        }
      ],
      dataSource: [],
      offsetDay: 7,               // 统计天数
      statisticalType: 0,       // 统计类型
      pageSize: 5,               // 统计数目
      offsetDayName: '近7天',
      pageSizeName: 'Top 5',
      isLoding: false,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />
    }
  },
  mounted () {
    // this.getRankingList()
  },
  methods: {
    //   打开弹窗
    open () {
      this.visible = true
      this.getRankingList()
    },
    //   选择时间
    selectDate (e) {
      this.offsetDay = this.dateList[e].num
      this.offsetDayName = this.dateList[e].date
      this.getRankingList()
    },
    // 选择排名
    selectRanking (e) {
      this.pageSize = this.ranking[e].num
      this.pageSizeName = this.ranking[e].name
      this.getRankingList()
    },
    // 确认选择
    handleOk () {

    },
    // tabs切换
    callback (e) {
      this.offsetDay = 7
      this.pageSize = 5
      this.offsetDayName = '近7天'
      this.pageSizeName = 'Top 5'
      this.statisticalType = parseInt(e) - 1
      this.getRankingList()
    },
    // 计算宽度
    getWidth (num) {
      let overallLength = this.dataSource[0].salesCount
      let percentage = (500 / overallLength) * num
      return percentage + 'px'
    },
    getRankingList () {
      let url = '/report/api/reportSales/pageListSalesTopProduct'
      let params = {
        companyId: this.$store.state.userInfo.companyId,
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        offsetDay: this.offsetDay,
        statisticalType: this.statisticalType
      }
      let data = {
        pageSize: this.pageSize
      }
      this.$store.state.tabLoding = true
      getSellReportList(url, params, {}, data).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result
          this.$store.state.tabLoding = false
        } else {
          this.$message.error(res.logMessage)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.ranking-list-model {
  width: 960px !important;
  height: 580px !important;
  .ant-modal-content {
    height: 580px !important;
  }
  .ranking-list {
    padding-bottom: 20px;
  }
  .ant-tabs-content {
    border: 1px solid #ebebeb;
    .ant-table-header {
      background: #f6f9fe !important;
    }
    .ant-table-body {
      max-height: 300px !important;
    }
    .ant-table-thead {
      tr {
        th {
          background-color: #f6f9fe !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td:nth-child(4) {
          padding-left: 0 !important;
          border-left: 1px solid #ff6204;
        }
      }
      .basics-row {
        .overflow-hidden {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
      .salesCount-seniority {
        height: 25px;
        line-height: 25px;
        padding-left: 10px;
        color: #ffffff;
        background: linear-gradient(90deg, #ff9804, #ffc204);
      }
    }
  }
}
</style>